import { Component, OnInit } from '@angular/core';

import { RxComposite } from '../model/rx-composite';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RxIconModule } from '@nrwl/rx-icon';
import { SafeUrlPipe } from 'libs/rx-pipes/src/lib/safe-url.pipe';

@Component({
  selector: 'nrwl-rx-video-composite',
  templateUrl: './rx-video-composite.component.html',
  styleUrls: ['./rx-video-composite.component.scss'],
  imports: [CommonModule, FormsModule, RxIconModule, SafeUrlPipe],
  standalone: true,
})
export class RxVideoCompositeComponent extends RxComposite implements OnInit {
  // videoURL = 'https://www.youtube.com/embed/ieDKkGkBBEM?autoplay=1';
  url = null;
  constructor() {
    super();
  }

  ngOnInit() {
    this.url = this.payload.url;
  }
}
